import { Component, Input, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';
import { ProcessCalculationStatistic } from 'src/app/shared/models/process-calculation-statistic';
import { ProcessCalculationStatisticService } from '../../../services/process-calculation-statistic.service';

@Component({
    standalone: false,
    selector: 'app-update-process-perf-stat-button',
    templateUrl: './update-process-perf-stat-button.component.html',
    styleUrls: ['./update-process-perf-stat-button.component.scss']
})
export class UpdateProcessPerfStatButtonComponent implements OnInit {
    @Input()
    process: ITaskModel;

    @Input()
    updateDataHandler: (data: ProcessCalculationStatistic[]) => void;

    constructor(private readonly pcsService: ProcessCalculationStatisticService) {}

    ngOnInit(): void {}

    updateProcessPerformanceStatistic() {
        if (!this.process) {
            return;
        }
        return this.pcsService
            .getProcessCalculationStatistics(this.process.state.toLocaleLowerCase(), this.process.id)
            .pipe(
                map((data: ProcessCalculationStatistic[]) => {
                    this.updateDataHandler(data);
                })
            );
    }
}
